import { createContext, useContext } from 'react';
import { type SegmentationListingPageProps } from '@/components/feature/searchDirectory/SearchDirectoryProps';

interface SearchDirectoryDataProviderProps {
  children: React.ReactNode;
  pageData: SegmentationListingPageProps['pageData'];
}

const SearchDirectoryDataContext = createContext<SegmentationListingPageProps['pageData'] | null>(
  null
);

export const SearchDirectoryDataProvider = ({
  children,
  pageData,
}: SearchDirectoryDataProviderProps) => {
  return (
    <SearchDirectoryDataContext.Provider value={pageData}>
      {children}
    </SearchDirectoryDataContext.Provider>
  );
};

export const useSearchDirectoryData = () => {
  const context = useContext(SearchDirectoryDataContext);

  if (!context) {
    throw new Error('useSearchDirectoryData must be used within a SearchDirectoryDataProvider');
  }

  return context;
};
